import React from 'react';
import './performance-tracker.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PerformanceTracker = props => {
    const { currentPerformance, maxPerformance, game } = props;

    return (
        <div
            className="performance-tracker"
            role="progressbar"
            aria-label={'performance: ' + currentPerformance}
            aria-live="assertive"
        >
            {Array.from(Array(maxPerformance), (performance, i) => {
                const performanceNotchClasses = classNames({
                    'performance-tracker__notch': true,
                    'performance-tracker__press-notch': game === 'press',
                    'performance-tracker__debate-notch': game === 'debate',
                    'performance-tracker__notch--completed':
                        maxPerformance - i <= currentPerformance,
                });
                return <span key={i} className={performanceNotchClasses} />;
            })}
        </div>
    );
};

PerformanceTracker.propTypes = {
    currentPerformance: PropTypes.number.isRequired,
    maxPerformance: PropTypes.number.isRequired,
    game: PropTypes.oneOf(['press', 'debate']),
};

export { PerformanceTracker };
